import { UserOrganizationODataRepo, UserOrganizationRepo } from "../../data/repo";
import { UserOrganizationModel } from "../../data/entities";
import { BaseEntityService } from "../BaseEntityService"


export class UserOrganizationService extends BaseEntityService<UserOrganizationModel, UserOrganizationRepo, UserOrganizationODataRepo> {
  constructor(){
    super(new UserOrganizationRepo(), new UserOrganizationODataRepo());
  }

  async getByUserIdAsync(userId:number) : Promise<number[]>{
    return await this.repo.getByUserIdAsync(userId);
  }
}

export default UserOrganizationService;
